import React, {useCallback, useEffect, useState} from "react";
import axios from "axios";
import {DOMEN_BASE} from "../../assets/config/constants";
import "./style.css";

export function SelectBase({
                               id,
                               labelText,
                               name,
                               _rooms_id,
                               _set_function,
                               _filter,
                               curr_id,
                           }) {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);

    const getDataSelect = useCallback(async () => {
        setIsLoading(true);

        try {
            // Примечание: _filter и name используются здесь
            const url = _filter ? "select_filter.php" : "select.php";

            const {data: responseData} = await axios.get(`${DOMEN_BASE}/data/${url}`, {
                params: {name_table: name, order_field: "ord"},
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            setData(responseData.records || []); // Примечание: setData используется здесь
        } catch (err) {
            alert(err.message);
            setData([]);
        } finally {
            setIsLoading(false); // Примечание: setIsLoading используется здесь
        }
    }, [
        // 2. Включаем все внешние зависимости функции
        _filter,
        name,
        setData,
        setIsLoading,
        // DOMEN (если это константа, не нужно; если это пропс/стейт, нужно)
    ]);

    useEffect(() => {
        getDataSelect().then(r => r);
    }, [_filter, getDataSelect]);


    return (
        <div className="select_div">
            <label htmlFor={id}>
                {labelText}

                <select
                    id={id}
                    name={name}
                    value={_rooms_id}
                    onChange={(e) => _set_function(e.target.value)}
                    disabled={isLoading}
                >
                    {/* При загрузке */}
                    {isLoading && <option>Загрузка...</option>}

                    {/* Данные */}
                    {!isLoading &&
                        data.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}

                    {/* Если данных нет */}
                    {!isLoading && data.length === 0 && (
                        <option value="">Нет данных</option>
                    )}
                </select>
            </label>
        </div>
    );
}

export default SelectBase;
